
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

export const  Hero = ({lang}) => {
  
  const Heros = useSelector((state) => state.cart.hero);



  const guarentee=[
    lang=== 'en' ? 'Years ' : 'سنين ',
    lang=== 'en' ? 'Months ' : 'شهور ',
    lang=== 'en' ? 'Days ' : 'ايام ',
  ]

  
  const guarentee_=[
    lang=== 'en' ? 'Year ' : 'سنة ',
    lang=== 'en' ? 'Month ' : 'شهر ',
    lang=== 'en' ? 'Day ' : 'يوم ',
  ]

  const [next,setNext] = useState(true)
  
   const [index,setIndex] = useState(0)
   const [show,setShow] = useState(false)

   useEffect(() => {
  
    setTimeout(() => {
      setShow(true);
  }, 500);
    
  }, []);





  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  
  function handleTouchStart(e) {
      setTouchStart(e.targetTouches[0].clientX);
  }
  
  function handleTouchMove(e) {
      setTouchEnd(e.targetTouches[0].clientX);
  }
  
  function handleTouchEnd() {
      if (touchStart - touchEnd > 175) {
          // do your stuff here for left swipe
          setNext(false)
          setShow(false)
       
          
         setTimeout(() => {
             setNext(true);
             if(index < Heros.length-1){
           setIndex(index+1)
         }else{
           setIndex(0)
         }
            }, 500);
         setTimeout(() => {
             setShow(true);
            }, 1000);
      }
  
      if (touchStart - touchEnd < -175) {
          // do your stuff here for right swipe
          setNext(true)
          setShow(false)
          
          setTimeout(() => {
              setNext(false);
              if(index > 0){
            setIndex(index-1)
          }else{
            setIndex(Heros.length-1)
          }
             }, 500);
           setTimeout(() => {
              setShow(true);
             }, 1000)
      }
  }





  return (
    <section className="bg-[#f4f4f4] bg-heroBG px-10 pt-28 max-h-screen  w-full rounded-none "
     onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd} 
    >
       
       
        <div className={` flex flex-col w-full  select-none`} >
          <div  className={`h-[200px] xs:h-[200px] sm:h-[250px]  md:h-[350px] lg:h-[450px]  xl:h-[500px] 
          ${show ? ' transition-all  duration-500   opacity-[1] translate-x-[0px] rotate-0' : `transition-all delay-200  duration-500  opacity-[0] ${next? 'translate-x-[120%]' : '-translate-x-[120%]'} `}`}>

            <div dir="rtl" className="flex gap-5 items-center  ">


            
              <div className={'ml-5 w-[45%]  '}>
                <div className="flex flex-col  w-full  ">
                    <div className="flex flex-col self-stretch my-auto text-zinc-800  ">
                      <h4 dir={lang=== 'en' ?  "ltr" : "rtl" }  style={{fontFamily:'CairoExtraBold',whiteSpace:'pre-wrap'}} className= {`${lang === 'en' ? 'text-left' :'text-right'} text-[#333333] w-full   text-[20px]  xl:text-[50px] xl:leading-[70px]  lg:text-[40px] lg:leading-[60px] md:text-[30px] md:leading-[50px]  sm:text-[20px] sm:leading-[40px] xs:text-[20px] xs:leading-[35px]`} >
                      {Heros.length > 0 ? 
                      
                      lang=== 'en' ? Heros[index].text_en  : Heros[index].text 
                      
                      :''}
                      </h4>
                      <Link to={`brand/${Heros.length > 0 ? Heros[index].agent_fid :''}`} className="self-center  max-w-full   w-[80%] max-w-[300px] mt-4  max-h-[180px]">
                      <img
                        src={`https://demo.future-swift.com/img/${Heros.length > 0 ? Heros[index].brand :''}`}
                        alt={Heros.length > 0 ?  Heros[index].brand_alt :''}
                        className="object-contain  max-w-full   w-[90%] max-w-[300px]  max-h-[180px] "
                      />
                       </Link>
                    </div>
                 
                  <Link to={`product/${Heros.length > 0 ? Heros[index].product :''}`} style={{fontFamily:'CairoBold'}} className= {`${lang === 'en' ? 'self-star' :'self-end '}  bg-primary bg-gradient-to-l from-[#f08190] mt-4   max-w-[250px]  w-[80%]   leading-none text-white rounded py-4 hover:opacity-[0.8]`}>
                   {lang === 'en' ? 'Details' :' إعرف أكثر'}
                  </Link>
                  
                </div>
              </div>



              <div className="relative w-[55%]   ">
                <img
                  src={`https://demo.future-swift.com/products/${Heros.length > 0 ? Heros[index].img :''}`}

                  alt={Heros.length > 0 ?  Heros[index].alt :''}
                  className={` m-auto object-contain  w-full  max-h-[200px] xs:max-h-[200px] sm:max-h-[250px]  md:max-h-[350px] lg:max-h-[450px]  xl:max-h-[500px]  
                  ${show ? 'transition-all delay-200  duration-500  opacity-[1] translate-x-[0px] rotate-0' : 'transition-all   duration-500  opacity-[1] translate-x-[100%] rotate-45'}  `}
                />
    
   {Heros.length > 0 ?

    Number(Heros[index].guarantee) > 0 ?

                <div  dir={lang=== 'en' ?  "ltr" : "rtl" } className={`absolute rounded bottom-[4%] left-[0] xl:left-[15%]  lg:left-[10%] md:left-[8%] sm:left-[0] xs:left-[0] flex w-[120px] h-[60px] bg-[#ffffff]/60 bg-gradient-to-b from-[#D7D7D7]/80 `}>
<p style={{fontFamily:'CairoExtraBold'}} className="w-[20%] text-[25px] m-auto text-[#333333]" >
{  Heros[index].guarantee }
</p>

<p style={{fontFamily:'CairoBold'}} className="w-[80%] m-auto text-[#333333]">
{Number(Heros[index].guarantee) > 1 ? guarentee[Heros[index].guarantee_type] : guarentee_[Heros[index].guarantee_type] }
 {  lang=== 'en' ? 'Guarantee ' : 'ضمانة '} 
</p>
</div>

:''

:''}
              </div>



              
            </div>



            
          </div>

          <div style={{overflowX:'hidden', maxWidth:'100%',zIndex:3}} dir="ltr" className="relative flex gap-4 items-center self-center py-5  ">
         
          <button 
          
          onClick={()=>{
            if(Heros.length > 0){
                setNext(true)
                setShow(false)
              
              setTimeout(() => {
                  setNext(false);
                  if(index > 0){
                setIndex(index-1)
              }else{
                setIndex(Heros.length-1)
              }
                 }, 500);
               setTimeout(() => {
                  setShow(true);
                 }, 1000)
                }
            }} aria-label="Previous slide">
              <img
                src="Icons/LeftButton.svg"
                alt=""
                className="object-contain shrink-0 self-stretch my-auto  w-[17px]"
              />
            </button>

          <div style={{overflowX:'auto', maxWidth:'80%'}} dir="ltr" className="flex gap-2 items-center self-center py-5  ">
         
            {Heros.map((item, i) => (
              <div key={`Slider ${i}`} onClick={()=>{
                    if(Heros.length > 0){
                if(i > index){
                  //prev
                  setNext(false)
                setShow(false)
              
              setTimeout(() => {
                  setNext(true);
                
                setIndex(i)
            
                 }, 500);
               setTimeout(() => {
                  setShow(true);
                 }, 1000)
                }
                else if(i < index){
                  //next
                  setNext(true)
                  setShow(false)
               
              setTimeout(() => {
                  setNext(false);
              
                  setIndex(i)
                 }, 500);

              setTimeout(() => {
                  setShow(true);
                 }, 1000)
                }
                    }
              }} className={`transition-all delay-150 duration-500 flex shrink-0 self-stretch my-auto h-4 rounded-full ${Number(i) === Number(index) ? 'bg-primary' : 'bg-zinc-300'}  w-[17px]`} />
          ))}
          
          </div>
          <button onClick={()=>{
                if(Heros.length > 0){
               setNext(false)
               setShow(false)
               
              setTimeout(() => {
                  setNext(true);
                  if(index < Heros.length-1){
                setIndex(index+1)
              }else{
                setIndex(0)
              }
                 }, 500);
              setTimeout(() => {
                  setShow(true);
                 }, 1000);
                }
            }} aria-label="Next slide">
              <img
                src="Icons/RightButton.svg"
                alt=""
                className="object-contain shrink-0 self-stretch my-auto aspect-[0.76] w-[17px]"
              />
            </button>


          </div>
        </div>

    </section>
  );
}
